/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Lägg till beställning",
  "i18n.additionalProducts.emotionalHook": "♥️ Vår favorit:",
  "i18n.additionalProducts.productDescription": "Produktbeskrivning",
  "i18n.additionalProducts.showMore": "Mer information",
  "i18n.additionalProducts.title": "Lämpliga tillbehör",
  "i18n.button.addToCart": "Lägg i kundvagn",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Tillämpa",
  "i18n.button.back": "Tillbaka",
  "i18n.button.cancel": "Avbryt",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Stäng",
  "i18n.button.continue": "Fortsätt",
  "i18n.button.ignore": "Ignorera",
  "i18n.button.ignoreAndContinue": "Fortsätt ändå",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Ingen förändring",
  "i18n.button.design": "",
  "i18n.button.photos": "Foton",
  "i18n.button.retry": "Försök igen",
  "i18n.button.uploadPhotos": "Ladda upp foto(n)",
  "i18n.button.withSmartSorted": "Med SMART SORTED",
  "i18n.button.withoutSmartSorted": "Utan SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Korta ner texten för att öka läsbarheten.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Det valda typsnittet är för stort för den här texten.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Maximalt typsnitt för texten har uppnåtts.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Minimalt typsnitt för texten har uppnåtts.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Korta ner texten för att öka läsbarheten.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Vänligen infoga en radbrytning",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Kontrollera din text, inte alla tecken stöds av denna typsnitt.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Korta ner texten för att öka läsbarheten.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Vänligen förstöra upp textfältet",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Det här steget kan inte ångras",
  "i18n.dialog.deletePlaceholder.title": "Verkligen ta bort platshållare?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Bildens upplösning är för låg för att skriva ut motivet optimalt!",
  "i18n.dialog.smartSorted.message": "Med SMART SORTED kan du lägga ditt motiv med 1000 bitar på ett innovativt och enkelt sätt, även utan en motivmall.",
  "i18n.dialog.smartSorted.title": "Garanterat framgångsrik pusselupplevelse",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klicka på \"{{text}}\", för att redigera lådtiteln.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Lådtiteln har inte redigerats",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Fortsätt utan lådtitel",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "En platshållare har inte redigerats",
    "En del platshållare har inte redigerats."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "icke redigerade platshållare",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Du har pausat designen under en längre tid. Det går inte att fortsätta. Vänligen starta processen igen.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Ett foto kunde inte laddas upp.  Det har exkluderats från galleriet och designprocessen.",
  "i18n.error.imageLoadingError.title": "Nedladdningsfel",
  "i18n.error.imageProvisionError.message": "Ett eller flera foton kunde inte bearbetas. Detta beror antagligen på att den valda medietypen inte stöds av systemet.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Filen \"{{reference1}}\" kunde inte bearbetas.",
  "i18n.error.imageSelectionError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.imageSizeLimitExceededError.message": "Bilden du har laddad upp är för stor.\nVänligen förminska bilden till mindre än 180 megapixlar och ladda upp den igen.",
  "i18n.error.imageSizeLimitExceededError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.imageUploadError.message": "Problem med internetanslutningen. \nVänligen försök igen senare.",
  "i18n.error.imageUploadError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Denna typsnitt är inte tillämplig, välj en annan typsnitt.",
  "i18n.error.invalidCharConfigError.title": "Typsnitt inte tillämpligt",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Det verkar som att din internetanslutning kopplades ner. Du kan fortsätta designa dina produkter så snart anslutningen har återställts.",
  "i18n.error.templateLoadingError.message": "Mallen \"{{ error.reference[0] }}\" kunde inte laddas.\nVänligen försök igen senare.",
  "i18n.error.templateLoadingError.title": "Nedladdningsfel",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\"  innehåller en otillåten medietyp.",
  "i18n.error.unsupportedMediaTypeError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.uploadProductError.message": "En eller flera produkter kunde inte överföras till servern. Vänligen försök igen senare.",
  "i18n.error.uploadProductError.title": "Överföringsfel",
  "i18n.error.zoomModeError.message": "Texten från din tidigare layout kunde inte antas. Vänligen ange en ny text.",
  "i18n.error.zoomModeError.title": "Text inte antagen",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Pris",
  "i18n.price.reduction": "Du sparar",
  "i18n.price.total": "Totalsumma",
  "i18n.priceDisplay.times": [
    "{{value}} styck à{{pricePerUnit}}",
    "{{value}} stycken à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Välj tillbehör",
  "i18n.progressOverlay.message.lines.one": "Tack för din design",
  "i18n.progressOverlay.message.lines.two": "Vi förbereder följande steg för dig ...",
  "i18n.template.insertText": "Skriv din text här",
  "i18n.toolbox.image.title": "Redigera foto",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} foton"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D-granskning",
  "i18n.toolbox.productChooser.title": "Byt produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Redigera text",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleSvSE {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
